import clsx from 'clsx';
import React, {
  ReactNode,
} from 'react';

type Props = Record<string, any> & {
  children: ReactNode;
  id: string | number;
};

export default function DefaultOptionContainer({
  children,
  id,
  ...props
}: Props) {
  return (
    <div
      {...props}
      key={id}
      className={clsx(
        props?.className,
        'flex items-center w-full',
      )}
    >
      {children}
    </div>
  );
}
